export default __webpack_public_path__ + "static/wwc-image10-07e1a95b9a82b33084fa143db853db6c.jpg";